import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/pro-solid-svg-icons'
// import {  } from '@fortawesome/pro-regular-svg-icons'
import { faEdit } from '@fortawesome/pro-light-svg-icons'
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add( faEdit, faSpinner, faInstagram, faFacebook )

// require('@fortawesome/fontawesome-pro/css/all.css');
// require('@fortawesome/fontawesome-pro/js/all.js');


Vue.component('fai', FontAwesomeIcon)